import type { ReactNode } from 'react'
import { FormattedMessage } from 'react-intl'

import { Placeholder } from '@/src/elements/placeholder'
import { IntentionPrayCard } from '@/src/features/intention/ui/components/IntentionPrayCard'
import type { TSourceParam } from '@/src/general/constants/routes'
import { TEST_ID } from '@/src/general/constants/testId'
import { useTrackDisplayed } from '@/src/general/hooks/useTrackOnce'
import { EVENTS } from '@/src/general/utils/gtm/constants'

import type { TRandomPopularIntentionApi } from '../../../api/types/getIntentionApi.types'
import { useRandomPopularUnprayedIntentionsQuery } from '../../../services/useRandomPopularUnprayedIntentionsQuery'

type TRandomIntention = TSourceParam & {
  testID: string
  onPrayPress: (intention: TRandomPopularIntentionApi) => void
}

export const RandomIntention = ({ testID, source, onPrayPress }: TRandomIntention): ReactNode => {
  const { intention, isLoading } = useRandomPopularUnprayedIntentionsQuery()

  useTrackDisplayed(EVENTS.POST_PRAY_INTENTION_CREATION_PRAY_INTENTION_DISPLAYED, 'INTENTION_CREATED', {
    trackingSource: source,
  })

  const handlePray = () => {
    if (!intention) return
    onPrayPress(intention)
  }
  const title = {
    default: (
      <FormattedMessage
        id="pray.intention.show"
        values={{
          user: intention?.user?.name,
        }}
      />
    ),
    prayed: (
      <FormattedMessage
        id="pray.intention.publication.done"
        values={{
          user: intention?.user?.name,
        }}
      />
    ),
  }

  if (isLoading) return <Placeholder testID={TEST_ID.INTENTION.RANDOM.LOADING} className="h-44" />
  if (!intention) return null

  return <IntentionPrayCard title={title} intention={intention} onPray={handlePray} testIdPrayButton={testID} />
}
